export default "__VITE_ASSET__asq$$aBZ__"